import { StandardEvents } from '@shopify/events';

/**
 * Keeps "€ / Portion" and "€ / kg" (blocks/product-price-per-serving.liquid) in
 * step with the selected variant — a 2,5 kg tub costs differently per kg than
 * the 1 kg one. Same pattern as the theme's product-price: when the variant
 * picker has fetched the new section HTML, take this block's fresh lines from it.
 */
class PricePerUnit extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section || this.closest('product-card')) return;
    this.section.addEventListener(StandardEvents.productSelect, this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
  }

  /** @param {any} event */
  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const fresh = html.querySelector(`price-per-unit[data-block-id="${this.dataset.blockId}"]`);
        if (fresh && fresh.innerHTML !== this.innerHTML) this.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('price-per-unit')) {
  customElements.define('price-per-unit', PricePerUnit);
}
